import { formatCartProduct } from "@/services/formater/cartProductFormater.js";
import { formatCartEssentialOption } from "@/services/formater/cartOptionEssentialFormater.js";
import { formatCartAdditionalOption } from "@/services/formater/cartOptionAdditionalFormater.js";

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const ADD_PRODUCT_TO_CURRENT_CART = (state, element) => {
  let product = element.product;
  let productId = product.product_id;
  let quantity = product.qty;
  let itemId = product.item_id;

  product.tax_percent ? state.currentCart.tva = product.tax_percent : false;

  if(element.nbTaxRates >= 2){
    state.currentCart.tva = null;
  }

  product ? state.currentCart.items.push(formatCartProduct(product)) : false;
  product ? state.currentCart.productIdList.push(product.product_id) : false;
  product ? (state.currentCart.productQuantityById[productId] = quantity) : false;
  product ? (state.currentCart.productItemIdById[productId] = itemId) : false;
};
/**
 *
 * @param {Object} state
 * @param {Object} option
 */
const ADD_ESSENTIAL_OPTION_TO_CURRENT_CART = (state, option) => {
  option
    ? state.currentCart.essentialOptions.push(
        formatCartEssentialOption(option, state.currentCart.productIdList),
      )
    : false;
};
/**
 *
 * @param {Object} state
 * @param {Object} option
 */
const ADD_INTERVENTION_OPTION_TO_CURRENT_CART = (state, element) => {

  let option = element.option;

  option
    ? state.currentCart.interventionOptions.push(
        formatCartEssentialOption(option, state.currentCart.productIdList),
      )
    : false;
  option ? state.currentCart.items.push(formatCartProduct(option)) : false;

  if(element.nbTaxRates >= 2){
    state.currentCart.tva = null;
  }
};

/**
 *
 * @param {Object} state
 * @param {Object} option
 */
const ADD_ADDITIONAL_OPTION_TO_CURRENT_CART = (state, option) => {
  option
    ? state.currentCart.additionalOptions.push(
        formatCartAdditionalOption(
          option,
          state.currentCart.productIdList,
          state.currentCart.productQuantityById,
          state.currentCart.productItemIdById,
        ),
      )
    : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_ERROR_MESSAGES = (state, cart) => {
  typeof cart.messages !== "undefined" && cart.messages.error && cart.messages.error.length > 0
    ? (state.currentCart.errorMessages = cart.messages.error)
    : false;
};
/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_COUPON_CODE = (state, cart) => {
  typeof cart.coupon_code !== "undefined"
    ? (state.currentCart.couponCode = cart.coupon_code)
    : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_CHECKOUT_URL = (state, cart) => {
  cart.checkout_url ? (state.currentCart.checkoutUrl = cart.checkout_url) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_TOTAL = (state, cart) => {
  cart.grand_total != "" ? (state.currentCart.total = cart.grand_total) : false;
};
/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_CGV = (state, cart) => {
  cart.cgv != "" ? (state.currentCart.cgv = cart.cgv) : false;
};

const SET_CUSTOMER_SERVICE_INFO = (state, cart) => {
  cart.customer_service_info != "" ? (state.currentCart.customerServiceInfo = cart.customer_service_info) : ""
}

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_SCHEDULE = (state, cart) => {
  cart.schedule ? (state.currentCart.schedule = cart.schedule) : false;
};
/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_DISCOUNT = (state, cart) => {
  cart.discount ? (state.currentCart.discount = cart.discount) : null;
};

/**
 * Details of all aids avalaible
 * @param {Object} state
 * @param {Object} cart
 */
 const SET_CURRENT_CART_DISCOUNT_DETAILS = (state, cart) => {
   if(cart.discount_details) {
    cart.discount_details.forEach(discount => {
       let discountDetails = {
          name: discount.name,
          couponType: discount.coupon_type,
          discount_amount: discount.discount_amount,
        }
        state.currentCart.discountDetails.push(discountDetails)
    });
   }
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_REFFERER_DISCOUNT = (state, cart) => {
  if (cart.referrer_discount) {
    let cobrandingRefferer = {
      name: cart.referrer_discount.name,
      totalPrice: cart.referrer_discount.price,
      type: "cobrandingRefferer",
    };
    state.currentCart.items.push(cobrandingRefferer);
  }
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_DELIVERY = (state, cart) => {
  cart.mcp_intervention_date != ""
    ? (state.currentCart.delivery.date = cart.mcp_intervention_date)
    : false;
  cart.mcp_intervention_slot != ""
    ? (state.currentCart.delivery.hours = cart.mcp_intervention_slot)
    : false;
};

const SET_CART_DELIVERY_DATE_NULL = (state) => {
  state.currentCart.delivery.date = null;
  state.currentCart.delivery.hours = null;
}


/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_DELIVERY_ABSOLUTE_TYPE = (state, type) => {
    type ? state.currentCart.delivery.type = type : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_DELIVERY_TYPE = (state, cart) => {
  if (cart.mcp_service === "installation") {
    state.currentCart.delivery.type = "delivery_and_installation";
  } else if (cart.mcp_service === "retail") {
    state.currentCart.delivery.type = "delivery_only";
  } else if (cart.mcp_service === "renting") {
    state.currentCart.delivery.type = "renting";
  }
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_ECO_TAX = (state, eco_tax) => {
  eco_tax != "" ? (state.currentCart.ecoTaxe = eco_tax) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const CLEAN_PRODUCTS_TO_CURRENT_CART = state => {
  state.currentCart.items = [];
  state.currentCart.productIdList = [];
};
/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const CLEAN_ESSENTIAL_OPTIONS_TO_CURRENT_CART = state => {
  state.currentCart.essentialOptions = [];
};
/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const CLEAN_ADDITIONAL_OPTIONS_TO_CURRENT_CART = state => {
  state.currentCart.additionalOptions = [];
};
/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const CLEAN_INTERVENTIONS_OPTIONS_TO_CURRENT_CART = state => {
  state.currentCart.interventionOptions = [];
};

const SET_CURRENT_CART_RENTING_AMOUNTS = (state, cart) => {
    typeof cart.renting_amounts != "undefined" ? (state.currentCart.rentingAmounts = cart.renting_amounts) : false;
};

const SET_CURRENT_CART_TOTAL_WITHOUT_DISCOUNT_REFERRER = (state, cart) => {
    typeof cart.amount_discount_without_referrer != "undefined" ? (state.currentCart.totalWithoutDiscountReferrer = cart.amount_discount_without_referrer) : false;
};

const SET_CURRENT_CART_TOTAL_ITEMS_COUNT = (state, cart) => {
    typeof cart.items_count != "undefined" ? (state.currentCart.itemsCount = cart.items_count) : 0;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
 const SET_CURRENT_CART_CONFIG = (state, cart) => {
  cart.config != "" ? (state.currentCart.config = cart.config) : false;
};

/**
 * @param {Object} state
 * @param {String} universe
 */
 const SET_MCP_UNIVERSE = (state, universe) => {
  state.currentCart.mcp_universe = universe;
}

/**
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_GTM_DATAS = ( state, cart) => {

    // Cart Datas
    cart.subtotal ? state.currentCart.gtmDatas.cartTotalExcluTax = Number(parseFloat(cart.subtotal).toFixed(2)) : "";
    cart.grand_total ? state.currentCart.gtmDatas.cartTotalIncluTax = Number(parseFloat(cart.grand_total).toFixed(2)) : "";

    // Product Count
    let count = 0;
    if(cart.items) {
      cart.items.forEach(item => {
          if(item.type && (item.type === "product" || item.type ==="essential_option")) {
              count += 1;
          }
      })
    }
    
    state.currentCart.gtmDatas.cartProductsTotal = count;

    // Main product in cart datas
    if (cart.items && cart.items.length > 0) {

        cart.items.forEach(item => {
            if(item.type == "product" && item.main_product === true) {
                const productDatas = {
                    'name': item.name,
                    'id': item.product_id,
                    'category': item.category,
                    'brand': item.mcp_brand,
                    'price': Number(parseFloat(item.base_price_incl_tax).toFixed(2)),
                    'sku': item.sku,
                    'quantity': item.qty
                }

                state.currentCart.gtmDatas.mainProducts.push(productDatas)
            }
        })

    }
}

const SET_MAIN_ITEM = (state, cart) => {
  if (cart.items && cart.items.length > 0) {
    cart.items.forEach(item => {
      if(item.type == "product" && item.main_product === true) {
        state.currentCart.mainItem = item;
      }
    })
  }
}

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CURRENT_CART_TOTAL_ITEMS_QTY = (state, cart) => {
    typeof cart.items_qty != "undefined" ? (state.currentCart.totalItemsQty = Math.trunc(parseInt(cart.items_qty))) : 0;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_STANDART_DELIVERY_IN_CART = (state, cart) => {
  state.currentCart.standardDeliveryInCart = cart.standard_delivery_in_cart;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_INSTALLATION_PRODUCT_IN_CART = (state, cart) => {
  state.currentCart.installationProductInCart = cart.installation_product_in_cart;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_CUSTOMER_TAX_ID = (state, cart) => {
  state.currentCart.customerTaxId = cart.customer_tax_class_id;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_TAX_HIGH_RATE = (state, cart) => {
  state.currentCart.taxHighRate = cart.tax_high_rate;
};

/**
 *
 * @param {Object} state
 * @param {Object} cart
 */
const SET_TAX_PROFILS = (state, cart) => {
  state.currentCart.taxProfils = cart.tax_profile;
};


export default {
  ADD_PRODUCT_TO_CURRENT_CART,
  ADD_ESSENTIAL_OPTION_TO_CURRENT_CART,
  ADD_ADDITIONAL_OPTION_TO_CURRENT_CART,
  ADD_INTERVENTION_OPTION_TO_CURRENT_CART,
  SET_CURRENT_CART_COUPON_CODE,
  SET_CURRENT_CART_TOTAL,
  SET_CURRENT_CART_ECO_TAX,
  SET_CURRENT_CART_DELIVERY,
  SET_CURRENT_CART_SCHEDULE,
  CLEAN_PRODUCTS_TO_CURRENT_CART,
  CLEAN_ADDITIONAL_OPTIONS_TO_CURRENT_CART,
  CLEAN_ESSENTIAL_OPTIONS_TO_CURRENT_CART,
  CLEAN_INTERVENTIONS_OPTIONS_TO_CURRENT_CART,
  SET_CURRENT_CART_DISCOUNT,
  SET_CURRENT_CART_DISCOUNT_DETAILS,
  SET_CURRENT_CART_CGV,
  SET_CURRENT_CART_CHECKOUT_URL,
  SET_CURRENT_CART_REFFERER_DISCOUNT,
  SET_CURRENT_CART_DELIVERY_TYPE,
  SET_CURRENT_CART_ERROR_MESSAGES,
  SET_CURRENT_CART_DELIVERY_ABSOLUTE_TYPE,
  SET_CURRENT_CART_RENTING_AMOUNTS,
  SET_CURRENT_CART_TOTAL_WITHOUT_DISCOUNT_REFERRER,
  SET_CURRENT_CART_TOTAL_ITEMS_COUNT,
  SET_CURRENT_CART_CONFIG,
  SET_CUSTOMER_SERVICE_INFO,
  SET_MCP_UNIVERSE,
  SET_CURRENT_CART_GTM_DATAS,
  SET_CART_DELIVERY_DATE_NULL,
  SET_MAIN_ITEM,
  SET_CURRENT_CART_TOTAL_ITEMS_QTY,
  SET_STANDART_DELIVERY_IN_CART,
  SET_INSTALLATION_PRODUCT_IN_CART,
  SET_CUSTOMER_TAX_ID,
  SET_TAX_HIGH_RATE,
  SET_TAX_PROFILS
};
